import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../AuthProvider';

import { buildPath } from '../utils/common';

import { privateRoutePaths } from './private.route.config';
import { publicRoutePaths } from './public.routes.config';
import roles from '@/constant/roles.config';
import { onboardingRoutePaths } from './onboarding.route.config';

const ProtectedRouteWrapper = ({ children, permissions = [] }) => {
    const { token, user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isOpUser, isAdmin } = useAuth();

    const location = useLocation();
    console.log("location >>>>>>>>>>>>>>>>> ", location);
    // Not logged in → redirect to login
    if (!token) {
        return <Navigate to={publicRoutePaths.LOGIN.path} replace />;
    }

    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        if (user && isOpUser) return roles.OPERATION_USER.prefix;
        if (user && isAdmin) return roles.ADMIN.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    const onboardingPrefix =
        `/${roles.ON_BOARDING.prefix}`;


    const isOnboardingRoute =
        location.pathname.startsWith(onboardingPrefix);

    console.log("user  ===========", user , "isOnboardingRoute ======== ", isOnboardingRoute);
     console.log("location search ==============",location.search );
    if(user && user.role_slug.slug === "PRE_KYC") {
        if(user.trade_mode_type === "SUPPLIER" && !isOnboardingRoute) {
            if(user.current_step > 0 && user.current_step < 4) {
                const path = buildPath(onboardingRoutePaths.STEPPER_FORM, {
                    id: user.member_id,
                });
                return <Navigate to={`/${roles.ON_BOARDING.prefix}${path}`} replace />;
            } else if(parseInt(user.current_step) === 4) {
                console.log("if in 49")
                if(location.search === "?payment=success") {
                    const path = buildPath(onboardingRoutePaths.STEPPER_FORM, {
                        id: user.member_id,
                    });
                    return <Navigate to={`/${roles.ON_BOARDING.prefix}/${path}`} replace />;
                } else {
                    console.log("Else at 56")
                }
            }
        } else {
            console.log("else in 60.............")
        }
    } else if(user && user.role_slug.slug === "END_USER") {
        if(user.trade_mode_type === "SUPPLIER" && isOnboardingRoute) {
            console.log("In if ==============");
            if(location.search === "?payment=success") {
               // console.log("In inner if ==============");
                //  const path = buildPath(onboardingRoutePaths.STEPPER_FORM, {
                //     id: user.member_id,
                // });
                console.log("In 70 ==============");
                return children ? children : <Outlet />;
                // return <Navigate to={`/${roles.ON_BOARDING.prefix}/${path}`} replace />;
            }
        } else {
            console.log("else .............74 ..");
        }
    }

    // If route requires permissions but user doesn't have them
    if (permissions.length > 0 && user && !permissions.includes(user.role_slug.slug)) {

        if (user.role_slug.slug === "VIEWER" || user.role_slug.slug === "OPERATION_USER" || user.role_slug.slug === roles.INQ_MANAGER.slug_name) {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} replace />;
        }
        if (user.role_slug.slug === "DEMO") {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} replace />;
        }

        if (user.role_slug.slug === "PRE_KYC") {
            // Need to add stepper from condition
            return <Navigate to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} replace />;
        }

        if (user.role_slug.slug === "END_USER") {
            return <Navigate to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} replace />;
        }

        // if (user.role_slug.slug === "ADMIN") {
        //     return <Navigate to={'/${}'} />
        // }
    }
    // Authorized → render children or nested routes
    return children ? children : <Outlet />;
};
export default ProtectedRouteWrapper;
